import Header from '../Header/Header'
import CommonHeroSection from '../commonherosection/CommonHeroSection'

const CareerHeroSection = () => {
  return (
    <CommonHeroSection
      wrapperClassName="relative min-h-[460px] 2xl:min-h-[65vh] overflow-hidden text-white"
      contentClassName="relative z-20 w-full"
    >
      <div className="relative z-10">
        <Header />

        <div className="mx-auto min-h-[460px] 2xl:min-h-[65vh] flex w-[90%] items-center justify-center">
          <div className="md:max-w-4xl lg:max-w-3xl xl:max-w-4xl 2xl:max-w-7xl text-center">
            <h1 className="font-rajdhani text-3xl font-semibold md:text-5xl lg:text-6xl xl:text-6xl 2xl:text-7xl">Build Systems That Matter With a Team That Cares</h1>
            <p className="mt-4 font-gilroy text-base leading-relaxed text-gray-400 md:text-lg lg:text-xl xl:text-2xl 2xl:text-4xl">
            The Coding Studio is not for everyone. We work on complex problems for demanding clients in regulated industries. We hold ourselves to high standards. We take accountability seriously. If that sounds like the environment where you thrive, we want to hear from you.
            </p>
          </div>
        </div>
      </div>
    </CommonHeroSection>
  )
}

export default CareerHeroSection
